import { createSlice } from "@reduxjs/toolkit";
import { JOB_SCREEN_LIST } from "../../constants";

const initialState = {
    screen: JOB_SCREEN_LIST,
}

const jobSlice = createSlice({
    initialState,
    name: "job",
    reducers: {
        set_job: (state, action) => {
            return {
                ...state,
                ...action.payload
            }
        },
    }
})

export default jobSlice.reducer;

export const {
    set_job,
} = jobSlice.actions;
